import React, { EffectCallback, ReactElement, useEffect } from 'react';
import { NavigateFunction, Params, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';

import { SupportTemplate } from '../../../types/entity.types';
import { RootState } from '../../../types/state/root.types';
import { SupportState } from '../../../types/state/support.types';

import { requestViewProgramme } from '../../../api/programme/programme.actions';
import {
  requestCreateSupportTemplate,
  requestUpdateSupportTemplate,
  requestViewSupportTemplate
} from '../../../api/support-template/support-template.actions';
import { requestViewMessageOverview, requestDeleteMessage } from '../../../api/support/support.actions';

import { UPCOMING } from '../../../utils/constants';

import Support from '../../../components/screens/programme/support/Support';

const SupportContainer = (): ReactElement => {
  const { supportTemplate, messageOverviews } = useSelector(({ support }: RootState): SupportState => support);

  const dispatch: Dispatch = useDispatch();

  const navigate: NavigateFunction = useNavigate();

  const { status, programmeExternalReference }: Params = useParams();

  useEffect((): ReturnType<EffectCallback> => {
    // @ts-expect-error TODO: Fix after adding types to programme actions
    dispatch(requestViewProgramme({ externalReference: programmeExternalReference }));
    // @ts-expect-error TODO: Fix after adding types to support template actions
    dispatch(requestViewSupportTemplate({ externalReference: programmeExternalReference }));

    let interval: NodeJS.Timeout;
    if (status !== UPCOMING) {
      // @ts-expect-error TODO: Fix after adding types to support actions
      dispatch(requestViewMessageOverview({ programmeExternalReference, showSpinner: true }));
      interval = setInterval((): void => {
        // @ts-expect-error TODO: Fix after adding types to support actions
        dispatch(requestViewMessageOverview({ programmeExternalReference }));
      }, 5000);
    }

    return (): void => clearInterval(interval);
  }, [programmeExternalReference, dispatch, status]);

  const openMessages = (chatExternalReference: string): void => {
    navigate(`/programmes/${status}/${programmeExternalReference}/support/${chatExternalReference}`);
  };

  const createSupportTemplate = (supportTemplate: SupportTemplate, redirectUrl?: string): void => {
    dispatch(
      // @ts-expect-error TODO: Fix after adding types to support template actions
      requestCreateSupportTemplate({
        input: {
          supportTemplate,
          programmeExternalReference
        },
        onSuccess: (): void => {
          if (redirectUrl) {
            navigate(redirectUrl);
          }
        }
      })
    );
  };

  const updateSupportTemplate = (supportTemplate: SupportTemplate, redirectUrl?: string): void => {
    dispatch(
      // @ts-expect-error TODO: Fix after adding types to support template actions
      requestUpdateSupportTemplate({
        input: {
          supportTemplate,
          programmeExternalReference
        },
        onSuccess: (): void => {
          if (redirectUrl) {
            navigate(redirectUrl);
          }
        }
      })
    );
  };

  const deleteMessage = (systemUserExternalReference: string): void => {
    dispatch(
      // @ts-expect-error TODO: Fix after adding types to support actions
      requestDeleteMessage({
        programmeExternalReference,
        systemUserExternalReference
      })
    );
  };

  return (
    <Support
      status={status as string}
      messageOverviews={messageOverviews}
      supportTemplate={supportTemplate}
      openMessages={openMessages}
      createSupportTemplate={createSupportTemplate}
      updateSupportTemplate={updateSupportTemplate}
      deleteMessage={deleteMessage}
    />
  );
};

export default SupportContainer;
